import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this._beforeVisit = this._flushDirty.bind(this)
    this._beforeUnload = this._flushDirty.bind(this)
    document.addEventListener("turbo:before-visit", this._beforeVisit)
    window.addEventListener("beforeunload", this._beforeUnload)
  }

  disconnect() {
    document.removeEventListener("turbo:before-visit", this._beforeVisit)
    window.removeEventListener("beforeunload", this._beforeUnload)
    this._flushDirty()
  }

  save(event) {
    this._submit(event.target)
  }

  _flushDirty() {
    const active = document.activeElement
    if (active && this.element.contains(active) && active.name) {
      this._submit(active)
    }
  }

  _submit(input) {
    const form = this.element
    const formData = new FormData()
    formData.append(input.name, input.value)

    const authenticity = form.querySelector('input[name="authenticity_token"]')
    if (authenticity) formData.append("authenticity_token", authenticity.value)

    const csrfToken = document.querySelector('meta[name="csrf-token"]')

    fetch(form.action, {
      method: "PATCH",
      headers: {
        "X-CSRF-Token": csrfToken ? csrfToken.content : "",
        "Accept": "application/json"
      },
      body: formData
    }).then(response => {
      if (response.ok) {
        input.classList.remove("profile-edit__input--error")
        const err = input.parentElement.querySelector(".profile-edit__error")
        if (err) err.remove()
      } else {
        return response.json().then(data => {
          input.classList.add("profile-edit__input--error")
          let err = input.parentElement.querySelector(".profile-edit__error")
          if (!err) {
            err = document.createElement("span")
            err.className = "profile-edit__error"
            input.parentElement.appendChild(err)
          }
          err.textContent = data.errors.join(", ")
        })
      }
    })
  }
}
